module.exports = __webpack_public_path__ + "img/Twist36.78fd6501.jpg";